module.exports = __webpack_public_path__ + "navocat.webp?2744fc2e5d975270c3ac4363645f3638";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/navocat.webp
// module id = 297
// module chunks = 0